module.exports = [
	"Erectile Dysfunction", 
	"Diarrhea",
	"Postpartum Depression",
	"Deafness",
	"Unwanted Pregnancy",
	"Monsters Under the Bed",
	"Hysteria",
	"Vestigial Tail",
	"Endless Hiccupping",
	"Yeast Infection",
	"Constipation",
	"AIDS",
	"Chicken Pox",
	"Headache",
	"Pink Eye",
	"Cancer",
	"Restless Leg Syndrome",
	"A Heart Attack",
	"Painful Gas",
	"An Erection Lasting More than Four Hours",
	"Sensitive Nipples",
	"Athlete's Foot",
	"Crabs",
	"Anal Leakage",
	"A Toothache",
	"Insomnia",
	"Halitosis",
	"Anorexia",
	"Obesity",
	"Menopause",
	"Polio",
	"Worms",
	"Rabies",
	"Scoliosis",
	"Ear Infection",
	"Stroke",
	"Parkinson's",
	"Urinary Tract Infection",
	"Infertility",
	"Diabetes",
	"Genital Warts",
	"Gingivitis",
	"Depression",
	"Fetal Alcohol Syndrome",
	"Hernia",
	"Dandruff",
	"Rectal Itching",
	"Snake bite",
	"Dyslexia",
	"Vaginal Dryness",
	"Urinary Incontinence",
	"Peanut Allergy",
	"Poison Ivy",
	"Premature Ejaculation",
	"Undescended Testicle", 
	"Fibromyalgia",
	"Narcolepsy"
];



// WEBPACK FOOTER //
// ./src/packs/diseases.js